import { camelCase } from "lodash";
import { Market } from "Providers/ListProvider/types";
import { contiguousUSBounds, usStateBounds } from "utils";

export const getMarketBounds = (markets?: Market[]) => {
  if (!markets?.length) return;
  if (typeof google === "undefined" || !google.maps?.LatLngBounds) return;

  const bounds = new google.maps.LatLngBounds();
  for (const market of markets) {
    if (market.type === "DMA") {
      const { lat, lon } = market.coords || {};
      if (
        typeof lat !== "number" ||
        typeof lon !== "number" ||
        isNaN(lat) ||
        isNaN(lon)
      )
        continue;
      bounds.extend({ lat, lng: lon });
      continue;
    }
    if (market.type === "State") {
      const name = camelCase(market.name);
      const stateBounds = market.bounds || usStateBounds[name]?.bounds;
      if (!stateBounds) continue;
      bounds.extend({ lat: stateBounds.south, lng: stateBounds.west });
      bounds.extend({ lat: stateBounds.north, lng: stateBounds.east });
      continue;
    }
    if (market.type === "Country") {
      const countryBounds = market.bounds || contiguousUSBounds;
      bounds.extend({ lat: countryBounds.south, lng: countryBounds.west });
      bounds.extend({ lat: countryBounds.north, lng: countryBounds.east });
      continue;
    }
  }
  if (bounds.isEmpty()) return;
  return bounds;
};
